import React, { useEffect, useMemo, useState } from "react";
import Rating from "@mui/material/Rating";
import { IoMdStar } from "react-icons/io";
import { MdExpandLess, MdExpandMore } from 'react-icons/md';
import TooltipSimple from "../Common/TooltipSimple";
import { formatNumber, getCurrency } from "../../utils/helper";

const options = {
  Live: "liveOffers",
  "All Offers": "allOffers",
};

const Offers = ({ data, settingsData }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [selectedOption, setSelectedOption] = useState("Live");
  const [visibleCount, setVisibleCount] = useState(10);
  const [hasMoreOffers, setHasMoreOffers] = useState(true);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const loadMoreOffers = () => {
    setVisibleCount(visibleCount + 10);
  };

  // Check if there are more offers to load
  const checkMoreOffers = () => {
    if (data?.[options[selectedOption]]?.length <= visibleCount) {
      setHasMoreOffers(false);
    } else {
      setHasMoreOffers(true);
    }
  };

  const getRating = (percentage) => {
    // Ensure percentage is between 0 and 100
    if (percentage < 0) percentage = 0;
    if (percentage > 100) percentage = 100;
    const stars = (percentage / 20).toFixed(1);

    return parseFloat(stars);
  };

  useEffect(() => {
    checkMoreOffers();
  }, [visibleCount, selectedOption, data]);

  const { fbaCount, fbmCount, amazonCount } = useMemo(() => {
    const sellers = data?.[options[selectedOption]] || [];
  
    let fba = 0;
    let fbm = 0;
    let amazon = 0;
  
    sellers.forEach((item) => {
      if (item.isAmazon) {
        amazon++;
      } else if (item.isFBA) {
        fba++;
      } else {
        fbm++;
      }
    });
  
    return { fbaCount: fba, fbmCount: fbm, amazonCount: amazon };
  }, [selectedOption, data]);
  


  return (
    <div
      className="flex flex-col w-full text-white"
    >
      <div className="">
        <div
          className="flex cursor-pointer items-center mb-2 justify-between"
          onClick={toggleAccordion}
        >
          <div
            className="mr-1 text-primary text-md font-bold"
          >
            Offers
          </div>
          <div className="text-primary">
            {isOpen ? <MdExpandMore className="w-6 h-6" /> : <MdExpandLess className="w-6 h-6" />}
          </div>
        </div>
        {isOpen && (
          <>
            <div className="flex items-center bg-secondary-bg rounded-md mb-3 md:w-1/3 w-full text-center">
              {Object.keys(options).map((option, index) => (
                <div
                  key={index}
                  className={`cursor-pointer w-full px-3 py-2 text-xs font-semibold rounded-md ${
                    selectedOption === option
                      ? "bg-primary text-primary-bg"
                      : "text-primary"
                  }`}
                  onClick={() => {
                    setVisibleCount(10);
                    setSelectedOption(option);
                  }}
                >
                  {option}
                </div>
              ))}
            </div>
            <div className="relative">
              <table
                className="w-full mt-2"
                style={{ fontSize: "13px", borderCollapse: "collapse" }}
              >
                <thead>
                  <tr className="text-xs font-semibold">
                    <div className="flex items-center justify-between text-center px-2">
                      <div className="p-1 flex-2">{'#'}</div>
                      <div className="p-1 flex-1">Seller</div>
                      <div className="p-1 flex-1">Stock</div>
                      <div className="p-1 flex-1">Price</div>
                      <div className="p-1 flex-1">Profit</div>
                      <div className="p-1 flex-1">ROI</div>
                    </div>
                  </tr>
                </thead>
                <tbody>
                  {data?.[options[selectedOption]]
                    ?.slice(0, visibleCount)
                    ?.map((property, index) => (
                      <tr key={index}>
                        <td className="p-0">
                          <div
                            className="text-center text-white bg-secondary-bg p-4 rounded-lg"
                            style={{
                              marginBottom: "4px",
                              marginTop: index === 0 ? "0" : "4px",
                              padding: "10px",
                            }}
                          >
                            <div className="flex items-center justify-between">
                              <div className="p-1 flex-2 text-center">
                                {index + 1}
                              </div>{" "}
                              {/* Serial Number */}
                              <div className="group relative cursor-pointer flex-1 text-center">
                                <a
                                  // className={`${
                                  //   property?.isAmazon
                                  //     ? "bg-[#644513]"
                                  //     : property?.isFBA
                                  //     ? "bg-[#592810]"
                                  //     : "bg-blue-900/40"
                                  // } rounded-lg flex-1 px-4 py-1`}
                                  // style={{
                                  //   border:
                                  //     property?.isFBA || property?.isAmazon
                                  //       ? "1px solid #d5a109"
                                  //       : "1px solid #3b82f6",
                                  // }}
                                  href={
                                    process.env.REACT_APP_CLIENT_URL +
                                    "/storefront-stalking?q=" +
                                    property?.sellerId
                                  }
                                  target="_blank"
                                >
                                  {property?.isAmazon
                                    ? "AMZ"
                                    : property?.isFBA
                                    ? "FBA"
                                    : "FBM"}
                                </a>
                                <TooltipSimple
                                  width={"auto"}
                                  CustomJsx={() => (
                                    <div className="flex items-center gap-y-1 flex-col py-1">
                                      <p className="text-medium">
                                        {property?.sellerName}
                                      </p>
                                      {!property?.isAmazon && (
                                        <div className="flex gap-x-1 items-center px-2">
                                          <Rating
                                            name="read-only"
                                            value={Number(
                                              getRating(property?.sellerRating)
                                            )}
                                            precision={0.1}
                                            readOnly
                                            style={{
                                              fontSize: "13px",
                                              color: "#76F99B",
                                            }}
                                            emptyIcon={
                                              <IoMdStar className="text-[#76F99B80]" />
                                            }
                                          />
                                          <span>{`(${formatNumber(
                                            property?.sellerRatingCount
                                          )})`}</span>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                />
                              </div>
                              <div className="p-1 flex-1 text-center">
                                {property?.stock || "-"}
                              </div>
                              <div className="p-1 flex-1 text-center">
                                {getCurrency(settingsData?.marketplace) + property?.price}
                              </div>
                              <div className="p-1 flex-1 text-primary text-center">
                                {getCurrency(settingsData?.marketplace) + property?.profit}
                              </div>
                              <div className="p-1 flex-1 text-primary text-center">
                                {property?.roi}
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>

              {hasMoreOffers && (
                <div className="flex justify-center">
                <button
                  onClick={loadMoreOffers}
                  className="mt-3 px-3 py-1 text-xs bg-primary/10 text-primary border border-primary/80 rounded-md"
                  >
                    Load More
                  </button>
                </div>
              )}
            </div>
             <div className="flex mb-2 text-white text-xs font-semibold mt-2">
              <div className="cursor-pointer bg-secondary px-2 py-1.5 rounded-lg mr-1">
                Offers: {fbaCount + fbmCount + amazonCount}
              </div>

              {fbaCount > 0 && (
                <div className="cursor-pointer bg-[#592810] border border-[#d5a109] px-2 py-1 rounded-lg mr-1">
                  FBA: {fbaCount}
                </div>
              )}

              {fbmCount > 0 && (
                <div className="cursor-pointer bg-blue-900/40 border border-blue-500 px-2 py-1 rounded-lg mr-1">
                  FBM: {fbmCount}
                </div>
              )}

              {amazonCount > 0 && (
                <div className="cursor-pointer bg-[#644513] border border-[#d5a109] px-2 py-1 rounded-lg mr-1">
                  AMZ: {amazonCount}
                </div>
              )}
            </div>
          </>
        )}
      </div>

    </div>
  );
};

export default Offers;
